import React from 'react';
import myImage from './kachel_walk-in-dusche.jpg';

const kachelWalkInDusche = () => {
    return (
        <img src={myImage} width="100" height="50" />
    )
}

export default kachelWalkInDusche;



